module.exports = __webpack_public_path__ + "static/ubuntu-medium-de3a6d819afca9e52159c2107e83b988.eot";